// extracted by mini-css-extract-plugin
export default {"projects_card_wrapper":"ProjectCardWrapper_projects_card_wrapper__wwJc1"};